/**
 * Frontend configuration
 */

// Get the base URL from environment or detect from current location
const getBaseUrl = (): string => {
  console.log('Environment variable REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
  
  // Check if we have an environment variable (for build-time configuration)
  if (process.env.REACT_APP_API_BASE_URL) {
    console.log('Using environment variable:', process.env.REACT_APP_API_BASE_URL);
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  console.log('Environment variable not found, using auto-detection');
  
  // Detect from current window location
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  
  // Default port mapping
  let port = '8000';
  
  // If we're on a specific port in development, use the backend port
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    port = '8000'; // Backend port
  } else {
    // In production, assume backend is on port 8000 or same port
    port = process.env.REACT_APP_API_PORT || '8000';
  }
  
  const autoDetectedUrl = `${protocol}//${hostname}:${port}`;
  console.log('Auto-detected URL:', autoDetectedUrl);
  return autoDetectedUrl;
};

// Get WebSocket URL
const getWebSocketUrl = (): string => {
  const baseUrl = getBaseUrl();
  const wsProtocol = baseUrl.startsWith('https://') ? 'wss://' : 'ws://';
  const urlWithoutProtocol = baseUrl.replace(/^https?:\/\//, '');
  
  return `${wsProtocol}${urlWithoutProtocol}`;
};

export const config = {
  // API base URL (e.g., http://localhost:8000 or https://api.yourserver.com)
  API_BASE_URL: getBaseUrl(),
  
  // WebSocket base URL (e.g., ws://localhost:8000 or wss://api.yourserver.com)
  WS_BASE_URL: getWebSocketUrl(),
  
  // Full WebSocket URL for chat
  getWebSocketChatUrl: (token: string, uid?: string, impersonatedUserId?: string | null) => {
    let url = `${getWebSocketUrl()}/ws?token=${encodeURIComponent(token)}`;
    if (uid) {
      url += `&uid=${encodeURIComponent(uid)}`;
    }
    if (impersonatedUserId) {
      url += `&impersonate=${encodeURIComponent(impersonatedUserId)}`;
    }
    return url;
  },
  
  // Full API URL helper
  getApiUrl: (path: string) => {
    // If path already starts with http/https, return as-is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // If path starts with /, remove it since we'll add it in baseUrl
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${getBaseUrl()}/${cleanPath}`;
  },
  
  // Environment detection
  isProduction: () => {
    // Check if NODE_ENV is set to production
    if (process.env.NODE_ENV === 'production') {
      return true;
    }
    
    // Check if REACT_APP_ENV is set to production
    if (process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'prod') {
      return true;
    }
    
    // Check if we're not on localhost
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1' && !hostname.includes('local')) {
      return true;
    }
    
    return false;
  }
};

// Log configuration for debugging
console.log('Frontend Configuration:', {
  API_BASE_URL: config.API_BASE_URL,
  WS_BASE_URL: config.WS_BASE_URL,
  current_location: window.location.href
});
